/**
 * Определение нативной платформы Capacitor (Android/iOS).
 */

import { Capacitor } from "@capacitor/core";

/** Приложение запущено внутри Capacitor, а не в браузере. */
export function isNativePlatform(): boolean {
  return Capacitor.isNativePlatform();
}
